'use client';

import { useState } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import CategoryFilter from './components/CategoryFilter';
import BlogGrid from './components/BlogGrid';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/lib/translations';

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const { currentLang } = useLanguage();

  return (
    <>
      <Header currentLang={currentLang} />
      <div className="min-h-screen bg-background pt-40 pb-20 px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="mb-12 text-center">
            <h1 className="text-5xl md:text-6xl font-bold tracking-tighter mb-4">
              {t('blog.title', currentLang)}
            </h1>
            <p className="text-lg text-muted-foreground">{t('blog.subtitle', currentLang)}</p>
          </div>

          {/* Category Filter */}
          <CategoryFilter
            currentLang={currentLang}
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
          />

          {/* Blog Grid */}
          <BlogGrid currentLang={currentLang} selectedCategory={selectedCategory} />
        </div>
      </div>
      <Footer currentLang={currentLang} />
    </>
  );
}
